const APP_HANDLE = import.meta.env.VITE_SHOPIFY_APP_HANDLE || 'unboxugc';

/** Shopify App Pricing hosts plan selection and the trial, outside the app iframe (open it in `_top`). */
export function pricingUrl(shopDomain: string, appHandle: string = APP_HANDLE): string {
  const store = shopDomain.replace('.myshopify.com', '');
  return `https://admin.shopify.com/store/${store}/charges/${appHandle}/pricing_plans`;
}
